import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import productService from '../services/productService';

const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(true);

  const fetchCategories = async () => {
    try {
      const data = await productService.getAllCategories();
      setCategories(data);
    } catch (error) {
      toast.error('Kategoriler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await productService.createCategory(newCategory);
      toast.success('Kategori eklendi.');
      setNewCategory({ name: '', description: '' });
      fetchCategories();
    } catch (error) {
      toast.error('Kategori eklenemedi.');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu kategoriyi silmek istediğinize emin misiniz?')) {
      try {
        await productService.deleteCategory(id);
        toast.success('Kategori silindi.');
        fetchCategories();
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex align-items-center mb-4">
        <Link to="/products" className="btn btn-outline-secondary me-3">
          <FaArrowLeft /> Geri
        </Link>
        <h2 className="mb-0">Kategori Yönetimi</h2>
      </div>

      <div className="row">
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm">
            <div className="card-header bg-white">
              <h5 className="mb-0">Yeni Kategori Ekle</h5>
            </div>
            <div className="card-body">
              <form onSubmit={handleCreate}>
                <div className="mb-3">
                  <label className="form-label">Kategori Adı</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    value={newCategory.name} 
                    onChange={(e) => setNewCategory({...newCategory, name: e.target.value})} 
                    required 
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Açıklama</label>
                  <textarea 
                    className="form-control" 
                    rows="2" 
                    value={newCategory.description} 
                    onChange={(e) => setNewCategory({...newCategory, description: e.target.value})}
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary w-100">
                  <FaPlus className="me-2" /> Ekle
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Kategori Adı</th>
                      <th>Açıklama</th>
                      <th>İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((cat) => (
                      <tr key={cat.id}>
                        <td>{cat.name}</td>
                        <td>{cat.description}</td>
                        <td>
                          <button onClick={() => handleDelete(cat.id)} className="btn btn-sm btn-outline-danger">
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                    {categories.length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">Kayıtlı kategori bulunamadı.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesPage;